import { Theme } from 'baseui/theme';

export const StandardBorder = (theme: Theme) => `1px solid ${theme.colors.mono400}`;
